import React, { FormEvent, useEffect, useRef, useState } from "react";
import { getBusinessAccount } from "../../apis/bussiness-accounts/get-bussiness-accounts";
import { getAllUsers } from "../../apis/users/get-all-users";
import DataTable, { TBody, TH, THead, TR } from "../DataTable";
import Modal from "../Modal";
import Pagination from "../Pagination";
import Spinner from "../Spinner";
import { IUser } from "./CreateServiceModal";
import Button from "../Button";
import { twMerge } from "tailwind-merge";
import Input from '../Input';

type UserType = "individual" | "business";

const UsersTable = ({
  isVisible,
  onHide,
  selectedUser,
  onSelectUser,
}: {
  isVisible: boolean;
  onHide: () => void;
  selectedUser: IUser | null;
  onSelectUser: (user: IUser | null) => void;
}) => {
  const [users, setUsers] = useState<IUser[]>([]);
  const [totalPages, setTotalPages] = useState(1);
  const [currentPage, setCurrentPage] = useState(1);
  const [search, setSearch] = useState("");
  const [loading, setLoading] = useState(false);
  const [userType, setUserType] = useState<UserType>("individual");

  const searchForm = useRef<HTMLFormElement>(null);

  const searchRef = useRef("");

  const getUsers = async () => {
    setLoading(true);
    let res;
    if (userType === "business") {
      res = await getBusinessAccount({
        page: currentPage.toString(),
        search: search || "",
      });
      if (res?.success) {
        setUsers(res?.data?.docs as IUser[]);
        setTotalPages(res?.data?.totalPages);
      }
    } else if (userType === "individual") {
      res = await getAllUsers(
        new URLSearchParams({
          page: currentPage.toString(),
          search: search || "",
        })
      );
      if (res?.success) {
        setUsers(res?.data?.docs);
        setTotalPages(res?.data?.totalPages);
      }
    }

    console.log(res, "res");
    setLoading(false);
  };

  const handleSearch = (e: FormEvent) => {
    e.preventDefault();
    setCurrentPage(1);
    setSearch(searchRef.current);
  };

  useEffect(() => {
    getUsers();
  }, [currentPage, search, userType]);

  const handleSelectUserType = (type: UserType) => {
    setUserType(type);
    setCurrentPage(1);
    setSearch("");
    onSelectUser(null);
    searchRef.current = "";
    searchForm.current?.reset();
  };



  return (
    <Modal isVisible={isVisible} onHide={onHide} heading='User and business'>
      <form ref={searchForm} onSubmit={handleSearch} className="mb-4 px-8">
        <div className="flex items-center gap-2 justify-center">
          <Input
            onChange={(e) => (searchRef.current = e.target.value)}
            placeholder="search"
            containerClassName='w-2/3 h-full md:w-auto'
            outerClassName='h-full'
            className="w-full md:w-52 outline-none input-primary h-8 md:h-10 rounded-lg"
          />
          <Button
            type="submit"
            className="w-1/3 md:w-32 min-h-0 h-8 md:h-10"
          >
            Search
          </Button>
        </div>
      </form>
      <div className="flex justify-center my-6">
        <div className="flex rounded-lg overflow-hidden shadow-sm">

          <Button
            onClick={() => handleSelectUserType("individual")}
            className={`w-44 rounded-l-lg rounded-r-none  transition-all min-h-0 h-8 md:h-10 ${userType === "individual"
              ? "bg-primary text-white"
              : "bg-white text-gray-700 hover:bg-gray-100"
              }`}
          >
            User
          </Button>

          <Button
            onClick={() => handleSelectUserType("business")}
            className={`w-44 border-l rounded-r-lg rounded-l-none transition-all min-h-0 h-8 md:h-10 ${userType === "business"
              ? "bg-primary text-white"
              : "bg-white text-gray-700 hover:bg-gray-100"
              }`}
          >
            Business
          </Button>

        </div>
      </div>
      {loading ? (
        <Spinner />
      ) : !loading && users.length === 0 ? (
        <div className='flex justify-center'>
          <p>No user found </p>
        </div>
      ) : (
        <div className='px-5'>
          <div className='md:block hidden'>
            <DataTable>
              <THead>
                <TR>
                  <TH>Username</TH>
                  <TH>Email</TH>
                  <TH>Phone</TH>
                </TR>
              </THead>
              <TBody>
                {users?.map((user) => (
                  <TR
                    className={twMerge(
                      "cursor-pointer",
                      selectedUser?._id === user?._id && "bg-primary text-white"
                    )}
                    onClick={() => onSelectUser(user)}
                    key={user?._id}
                  >
                    <TH className="align-middle ">
                      <p
                        className={twMerge(
                          "truncate whitespace-nowrap max-w-[180px] text-md text-black font-normal",
                          selectedUser?._id === user?._id && "text-white"
                        )}
                      >
                        {user.fullName}
                      </p>
                    </TH>
                    <TH className="align-middle ">
                      <p
                        className={twMerge(
                          "text-md max-w-[240px] whitespace-nowrap truncate text-black font-normal",
                          selectedUser?._id === user?._id && " text-white"
                        )}
                      >
                        {user.email}
                      </p>
                    </TH>
                    <TH
                      className={twMerge(
                        "align-middle text-black font-normal whitespace-nowrap",
                        selectedUser?._id === user?._id && " text-white"
                      )}
                    >
                      {user.phone}
                    </TH>
                  </TR>
                ))}
              </TBody>
            </DataTable>
          </div>

          <div className="block md:hidden">
            {users?.map((user) => (
              <div
                key={user?._id}
                onClick={() => onSelectUser(user)}
                className={twMerge(
                  "cursor-pointer p-4 mb-2 rounded-lg shadow-sm border border-gray-100 bg-white flex flex-col gap-1",
                  selectedUser?._id === user?._id && "bg-primary text-white border-primary"
                )}
              >
                <p className={twMerge(
                  "font-semibold text-sm truncate",
                  selectedUser?._id === user?._id ? "text-white" : "text-black"
                )}>
                  {user.fullName}
                </p>
                <p className={twMerge(
                  "text-sm truncate",
                  selectedUser?._id === user?._id ? "text-white" : "text-gray-500"
                )}>
                  {user.email}
                </p>
                <p className={twMerge(
                  "text-sm",
                  selectedUser?._id === user?._id ? "text-white" : "text-gray-500"
                )}>
                  {user.phone}
                </p>
              </div>
            ))}
          </div>

          <div className="mt-4 ">
            <Pagination
              currentPage={currentPage}
              page={totalPages}
              handlePageClick={(e: { selected: number }) =>
                setCurrentPage(e.selected + 1)
              }
            />
          </div>
        </div>
      )}



      <div className="col-start-1 col-end-3 flex justify-end mt-3 mr-3">
        <Button
          onClick={onHide}
          className="w-32 min-h-0 h-10 md:h-10"
          disabled={selectedUser === null}
        >
          Save
        </Button>
      </div>

    </Modal>
  );
};

export default UsersTable;
